export default "__VITE_ASSET__CYGaO2NI__"